export default __webpack_public_path__ + "static/media/2106.981f5dbb.png";